import { memo } from 'react';
import {
  Box,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Text,
  Flex,
} from '@chakra-ui/react';

import BuilderModeSvgIcon from 'pages/BuilderModeV1/icons/BuilderModeSvgIcon';
import { BUILDER_MODE_V1_LAYOUT, BUILDER_MODE_V1_TOKENS } from 'pages/BuilderModeV1/constants';
import { capitalizeFirstLetter } from 'utils/GlobalHelpers';

import toolbarDropdownButtonStyles from './toolbarDropdownButtonStyles';

const DATA_TYPE_OPTIONS = [
  { name: 'Number', value: 'number' },
  { name: 'Statistic', value: 'statistic' },
  { name: 'Percentage', value: 'percentage' },
  { name: 'Ratio', value: 'ratio' },
  { name: 'Balance', value: 'balance' },
  { name: 'Opening balance', value: 'opening_balance' },
] as const;

export interface DataTypeDropdownProperties {
  dataType: string;
  onChange: (value: string) => void;
}

const DataTypeDropdown = memo(({ dataType, onChange }: DataTypeDropdownProperties) => {
  const normalizedValue = dataType?.toLowerCase() ?? '';

  return (
    <Menu variant='secondary' isLazy>
      <MenuButton
        as={Box}
        sx={{ ...toolbarDropdownButtonStyles, flex: 1, minW: 0 }}
        aria-label='Data type'
      >
        <Flex align='center' gap='12px' flex='1' minW={0}>
          <Text
            flex='1'
            minW={0}
            fontFamily={BUILDER_MODE_V1_LAYOUT.toolbarFontFamily}
            fontSize='14px'
            fontWeight='600'
            color={BUILDER_MODE_V1_TOKENS.textDark}
            lineHeight='normal'
            textAlign='left'
            noOfLines={1}
          >
            {capitalizeFirstLetter(dataType)}
          </Text>
          <BuilderModeSvgIcon name='chevronDown' width={9} height={6} />
        </Flex>
      </MenuButton>
      <MenuList zIndex={16} borderRadius='10px' borderColor={BUILDER_MODE_V1_TOKENS.border}>
        <MenuOptionGroup value={normalizedValue} onChange={(value) => onChange(String(value))}>
          {DATA_TYPE_OPTIONS.map((option) => (
            <MenuItemOption
              key={option.value}
              value={option.value}
              bg={
                normalizedValue === option.value ? BUILDER_MODE_V1_TOKENS.activeBg : 'transparent'
              }
            >
              {option.name}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
});

DataTypeDropdown.displayName = 'DataTypeDropdown';

export default DataTypeDropdown;
